import { render, staticRenderFns } from "./ResetPW.vue?vue&type=template&id=378969e8&scoped=true&"
import script from "./ResetPW.vue?vue&type=script&lang=js&"
export * from "./ResetPW.vue?vue&type=script&lang=js&"
import style0 from "./ResetPW.vue?vue&type=style&index=0&id=378969e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378969e8",
  null
  
)

export default component.exports